// extracted by mini-css-extract-plugin
export default {"root":"CardTable_root__e-ggW","cardTable":"CardTable_cardTable__v0gvZ","slim":"CardTable_slim__r8VS3"};